import { Box, Tabs }           from "@mantine/core";
import PropTypes               from "prop-types";
import { useEffect, useState } from "react";

import Typography  from "_components/atoms/typography";
import GrowthTable from "_components/pages/growthDashboard/table";
import useStyles   from "_styles/pages/growthDashboard/tab";

const GrowthPageTab = ( { data, isLoading, tabVal, setTabVal, userProfile } ) => {

	const [ total, setTotal ] = useState ( 0 );

	const handleChange = ( event, newValue ) => {
		setTabVal ( newValue );
	};

	function getTotal () {
		if ( tabVal === "d1Data" )
			return 0;

		return Array.isArray ( data ) && data.reduce ( ( acc, val ) => {
			return ( acc + val.count );
		}, 0 );
	}

	useEffect ( () => {

		const res = getTotal ();

		setTotal ( res );
	}, [ data ] );
	const { classes } = useStyles ( undefined, { name: "styles" } );

	const renderTable = (
		<div style = { { display: "flex", justifyContent: "center" } }>
			<GrowthTable
				loading   = { isLoading }
				tab       = { tabVal }
				tableData = { data }
			/>
		</div>
	);

	return (
		<Box className = { classes.growthPageTabsContainer }>
			{

				<Typography
					className = { classes.totalText }
					title     = { total ? `Total : ${ total }` : "" }
				>
				</Typography>
			}

			<Box>
				<Tabs centered
					aria-label     = "basic tabs example"
					className      = { classes.tabContainer }
					defaultValue   = "downloads"
					indicatorColor = "secondary"
					onChange       = { setTabVal }
					textColor      = "secondary"
					value          = { tabVal }
				>
					<Tabs.List m = "md">
						<Tabs.Tab className = { classes.tabText }
							label              = "Downloads"
							p                  = "xl"
							sx                 = { { width: "33%" } }
							{ ...a11yProps ( 0 ) }
							value              = "downloads"
						>
							Downloads

						</Tabs.Tab>

						<Tabs.Tab className = { classes.tabText }
							label              = "Sign Ups"
							p                  = "xl"
							sx                 = { { width: "33%" } }
							{ ...a11yProps ( 1 ) }
							value              = "signups"
						>
							Sign Ups

						</Tabs.Tab>

						<Tabs.Tab className = { classes.tabText }
							label              = "D1 Retention"
							// m = "xs"
							p                  = "xl"
							sx                 = { { width: "33%" } }
							{ ...a11yProps ( 2 ) }
							value              = "d1Data"
						>
							D1 Retention

						</Tabs.Tab>

					</Tabs.List>

					<Tabs.Panel index = { "downloads" }
						value            = "downloads"
					>
						{ renderTable }
					</Tabs.Panel>

					<Tabs.Panel index = { "signups" }
						value            = "signups"
					>
						{ renderTable }
					</Tabs.Panel>

					<Tabs.Panel index = { "d1Data" }
						value            = { "d1Data" }
					>
						{ renderTable }
					</Tabs.Panel>
				</Tabs>
			</Box>

		</Box>
	);
};

TabPanel.propTypes = {
	children : PropTypes.node,
	index    : PropTypes.number.isRequired,
	value    : PropTypes.number.isRequired
};

function a11yProps ( index ) {
	return {
		id              : `simple-tab-${ index }`,
		"aria-controls" : `simple-tabpanel-${ index }`
	};
}

function TabPanel ( props ) {
	const { children, value, index, ...other } = props;

	return (
		<div
			aria-labelledby = { `simple-tab-${ index }` }
			hidden          = { value !== index }
			id              = { `simple-tabpanel-${ index }` }
			role            = "tabpanel"
			{ ...other }
		>
			{value === index && (
				<Box>
					<Typography title = { children } />
				</Box>
			)}
		</div>
	);
}

export default GrowthPageTab;
